import React from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
// import heroImg from "../assets/images/andaman-hero.webp";
// import tadobaImg from "../assets/images/Home2.jpeg";
// import kashmirImg from "../assets/images/Home3.jpeg";
// import mowgliImg from "../assets/images/Home1.jpeg";
// import charDhamImg from "../assets/images/Home4.webp";
// import siddhagiriImg from "../assets/images/home5.webp"; // Add this image
import kailashImg from "../assets/images/home6.jpeg"; // Add this image
import valleyFlowersImg from "../assets/images/ValleyofFlowersTrekwithGypsyClub.jpeg";
import pinBhabaImg from "../assets/images/PinBhabaPassTrekOrganizedbyGypsyClub.jpeg";
function Tourdetails() {
  const { id } = useParams();

  // Complete tour data (same as in Tour component)
  const tours = [
    {
      id: 1,
      img: require("../assets/images/Home2.jpeg"),
      bannerImg: require("../assets/images/wild.webp"),
      title: "वाईल्डलाईफ अ‍ॅडव्हेंचर - ताडोबा व्याघ्र प्रकल्प",
      date: "May 16-18, 2026",
      author: "Gypsy Club",
      desc: "३ दिवस / २ रात्र | ४ ओपन जिप सफारी | वाघांचे दर्शन | आरामदायी निवास | ₹20,000/- Ex. Nagpur",
      fullDescription: "परीक्षा संपल्या आहेत? आता वेळ आहे पुस्तकांचे ओझे बाजूला सारून वाघांच्या राज्यात हरवून जाण्याची! \n \n ताडोबाच्या घनदाट जंगलात वाघाची डरकाळी आणि निसर्गाची जादू तुमचा अनुभव घेण्यासाठी सज्ज आहे. खास विद्यार्थ्यांसाठी आणि फॅमिलीसाठी जिप्सी वाईल्ड लाईफ सफारी घेऊन आलो आहोत एक अविस्मरणीय 'वाईल्डलाईफ अ‍ॅडव्हेंचर'! \n \n🐯 ताडोबा-अंधारी व्याघ्र प्रकल्प: विशेष जंगल सफारी \n ​बॅच१: १६-१८ मे २६\n(मोजक्या जागा शिल्लक)\nबॅच २ :०२ ते ०४ जून २६\n(बुकिंग चालू आहे)\nकालावधी ३ दिवस / २ रात्र\nशुल्क 20000 ex नागपूर\n\n​टूरची खास वैशिष्ट्ये:\n​४ ओपन जिप सफारी: वाघांचे दर्शन घडवण्यासाठी तज्ज्ञ गाईड्ससोबत ४ वेळा जंगलात प्रवेश.\n​आरामदायी निवास: निसर्गाच्या सानिध्यात लक्झरी रिसॉर्टमध्ये राहण्याची सोय.\nअस्सल वैदर्भीय आणि सुग्रास  भोजन.\n​\nनिसर्ग परिचय: ताडोबातील जैवविविधता, पक्षी निरीक्षण आणि फोटोग्राफी टिप्स. \n परीक्षांच्या थकव्यानंतर मेंदूला ताजेतवाने करण्यासाठी निसर्गापेक्षा उत्तम औषध नाही. आम्ही तुम्हाला फक्त फिरवत नाही, तर जंगलाची ओळख करून देतो!\n​\nसुरक्षितता: विद्यार्थ्यांसाठी आणि कुटुंबांसाठी पूर्णपणे सुरक्षित नियोजन.\n​अनुभव: वाघांच्या हालचालींचा अचूक अंदाज असणारे अनुभवी चालक आणि गाईड्स.\n​मज्जा मस्ती: रात्री कॅम्पफायर आणि गप्पांची मैफल.\n​\n📍 बुकिंगसाठी आजच संपर्क साधा!  सफारी  रद्द झाल्यास आर्थिक काळजी नको! जमा केलेली रक्कम पुढील टूरसाठी वापरण्याची विशेष सुविधा उपलब्ध.( नियम आणि अटी लागू)\n​जागा मर्यादित आहेत, कारण वाघांच्या राज्यात एन्ट्री फुल्ल होण्याआधी आपला स्लॉट बुक करा.​\n\n📞 संपर्क: [निनाद 9689938912 8484037008]\n​चला, या सुट्टीत अभ्यासाच्या टेन्शनला 'टाटा' करूया आणि वाघाला 'हॅलो' म्हणूया!",
      price: "₹20,000/-",
      advance: "Ex. Nagpur",
      duration: "3 Days / 2 Nights",
      location: "Tadoba, Maharashtra",
      contactValue: "tadoba",
      bgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      features: null
    },
    {
      id: 2,
      img: require("../assets/images/Home3.jpeg"),
      bannerImg: require("../assets/images/tulip.jpg"),
      title: "ट्युलिप स्पेशल ऑफबीट काश्मीर टूर",
      date: "April 8-12, 2026",
      author: "Gypsy Club",
      desc: "५ दिवस / ४ रात्री | ट्युलिप गार्डन | दाल लेक शिकारा | गुलमर्ग गोंडोला | दुधपोखरी | ₹20,500/- per person",
      fullDescription: "जिप्सी क्लब आयोजित... 🏔️ ट्युलिप स्पेशल ऑफबीट काश्मीर टूर 🌸\n\nचला अनुभवूया काश्मीरचा खरा स्वर्ग! ट्युलिपच्या रंगीबेरंगी फुलांचा उत्सव आणि गर्दीपासून दूर असलेल्या 'दुधपोखरी'चे सौंदर्य!\n\n🗓️ कालावधी: ५ दिवस / ४ रात्री (८ एप्रिल ते १२ एप्रिल २०२६)\n\n📍 प्रमुख आकर्षणे:\n🌷 आशियातील सर्वात मोठे ट्युलिप गार्डन\n🛶 दाल लेकमध्ये निवांत शिकारा राईड\n🚠 गुलमर्गची रोमांचक गोंडोला राईड\n🥛 दुधपोखरी - ऑफबीट व्हॅली ऑफ मिल्क\n🏡 हाऊस बोटमधील शाही मुक्काम\n\n✅ समाविष्ट: निवास, नाश्ता, रात्रीचे जेवण आणि पूर्ण प्रवास (Private Vehicle).\n\n📞 आजच आपली जागा निश्चित करा: निनाद 9689938912 / 8484037008\n✨ मर्यादित जागा उपलब्ध! लवकर बुकिंग करणाऱ्यांना विशेष सवलत (फ्लाईट बुकिंग at actual basis)",
      price: "₹20,500/-",
      advance: "Per Person",
      duration: "5 Days / 4 Nights",
      location: "Kashmir",
      contactValue: "kashmir",
      bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      features: null
    },
    {
      id: 3,
      img: require("../assets/images/Home1.jpeg"),
      bannerImg: require("../assets/images/wild.webp"),
      title: "मोगली समर कॅम्प",
      date: "April 24-26 / May 1-3, 2026",
      dates: [
        "April 24-26, 2026",
        "May 1-3, 2026"
      ],
      author: "Gypsy Club",
      desc: "३ दिवस / २ रात्री | वयोगट ८-१६ | जंगल ट्रेकिंग | तारांगण | कॅम्प फायर | ₹8,000/- per child",
      fullDescription: "🌿 'मोगली समर कॅम्प' - निसर्गाच्या कुशीत एक साहसी अनुभव! 🐾 जिप्सी क्लब आयोजित\n\nपालकांनो, आपल्या मुलांना द्या 'जंगल बुक'मधील मोगलीसारखा निसर्गाच्या कुशीतील अनुभव! 🌳🎒\n\nया उन्हाळ्यात मुलांच्या हातातील मोबाईल बाजूला ठेवा आणि त्यांना घेऊन चला खऱ्या निसर्गाच्या सफारीवर. जिथे असेल धम्माल, मस्ती आणि बरंच काही शिकण्याची संधी!\n\n📍 दिनांक: २४,२५,२६ एप्रिल २०२६ (दुसरी बॅच: १,२,३ मे २०२६)\n⏱️ कॅम्पचा कालावधी: ३ दिवस / २ रात्री\n🧒 वयोगट: ८ ते १६ वर्षे\n\nकॅम्पची खास वैशिष्ट्ये:\n🥾 जंगल ट्रेकिंग: 'बघीरा'सारखे चपळ बना आणि निसर्गाच्या पाऊलखुणा ओळखा.\n🏰 ऐतिहासिक शोध: भोर परिसरातील अनेक ऐतिहासिक ठिकाणांची सफर.\n✨ तारांगण (Star Gazing): 'का' (Kaa) प्रमाणे रात्रीच्या शांत आकाशात ताऱ्यांची जादू पाहा.\n🎨 निसर्ग चित्रकला: निसर्गाच्या सानिध्यात बसून स्वतःचे 'जंगल बुक' रेखाटा आणि फोटोग्राफी.\n🔥 कॅम्प फायर आणि गोष्टी: रात्रीच्या वेळी मोगली आणि त्याच्या मित्रांच्या साहसी गोष्टी.\n\nआमची सोय:\n✅ तज्ज्ञ मार्गदर्शक आणि सुरक्षित वातावरण.\n✅ सकस आणि पौष्टिक जेवण.\n✅ राहण्यासाठी सुरक्षित कॉटेज.\n\n📍 ठिकाण: भोर प्लॅटिनम रिसॉर्ट\n🚀 प्रवेश मर्यादित! आजच आपल्या 'छोट्या मोगली'चे नाव नोंदवा!\n📞 संपर्क: निनाद थत्ते 9689938912",
      price: "₹8,000/-",
      advance: "Per Child",
      duration: "3 Days / 2 Nights",
      location: "Bhor, Maharashtra",
      contactValue: "mowgli-camp",
      bgColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      features: null
    },
    {
      id: 4,
      img: require("../assets/images/Home4.jpeg"),
      bannerImg: require("../assets/images/chardhamb.jpg"),
      title: "पावन चार धाम यात्रा २०२६",
      date: "June 11-20, 2026",
      author: "तीर्थसारथी",
      desc: "९ रात्री / १० दिवस | यमुनोत्री | गंगोत्री | केदारनाथ | बद्रीनाथ | ₹46,000/- Ex. मुंबई",
      fullDescription: `🚩 ।। तीर्थसारथी आयोजित: पावन चार धाम यात्रा २०२६ ।। 🚩
​अनुभवा हिमालयाचे पावित्र्य, भक्ती आणि निसर्गाचा अनमोल संगम!
​यंदाची वारी, निसर्गाच्या कुशीत... 'तीर्थसारथी'सोबत! आम्ही घेऊन आलो आहोत एक अशी आध्यात्मिक यात्रा.
​🗓️ सहलीचा कालावधी:
११​ जून (गुरुवार) ते २० जून २०२६ (शनिवार)
(९ रात्री / १० दिवस – हरिद्वार ते हरिद्वार)
​✨ यात्रेची प्रमुख वैशिष्ट्ये:
• ​👤 वैयक्तिक लक्ष: प्रत्येक यात्रेकरूच्या सोयीची आणि सुखाची वैयक्तिक रित्या काळजी.
• ​🚩 अनुभवी टूर लीडर: हिमालयातील दुर्गम मोहिमांचा  अनुभव आणि तीर्थक्षेत्रांची सखोल माहिती असलेल्या तज्ज्ञांची  सोबत .
• शारीरिक आणि मानसिक पूर्वतयारी (Pre-Trip Coaching)
• ​🌿 शाश्वत पर्यटन (Sustainable Tourism): आम्ही पर्यावरणाची हानी होणार नाही याची पूर्ण काळजी घेतो. 'प्लास्टिक-मुक्त' प्रवासाचा आमचा मानस आहे.
• ​🏛️ वारसा जतन: केवळ दर्शनच नाही, तर आपल्या प्राचीन मंदिरांचा इतिहास आणि वारसा समजून घेण्याची सुवर्णसंधी.
• ​🤝 सुरक्षित आणि शिस्तबद्ध नियोजन: ज्येष्ठ नागरिकांसाठी विशेष सोयी आणि सुरक्षित प्रवासाची खात्री.
​📍 मुख्य आकर्षणे:
​यमुनोत्री • गंगोत्री • केदारनाथ • बद्रीनाथ
​"तीर्थसारथी सोबतचा प्रवास म्हणजे केवळ पर्यटन नाही, तर मनाला शांती देणारा एक आध्यात्मिक अनुभव!"
भक्ती, शक्ती आणि निसर्गाचा हा त्रिवेणी संगम अनुभवा. आजच तुमची जागा आरक्षित करा!
शुल्क Ex मुंबई ४६००० ₹ , जेष्ठ नागरिक आणि ग्रुप साठी विशेष सवलत उपलब्ध ,टूर अँडव्हान्स ५०%
शुल्कात समाविष्ट ( मुंबई ते दिल्ली आणि परत राजधानी एक्सप्रेस 3AC श्रेणी,यात्रेतील डिलक्स श्रेणी निवास ,नाष्टा आणि रात्रीचे भोजन,(MAP plan) , खाजगी आरामदायी  वाहनाने प्रवास, )
नोट: प्रवास रद्द झाल्यास आर्थिक काळजी नको! जमा केलेली रक्कम पुढील पटूरसाठी वापरण्याची विशेष सुविधा उपलब्ध."(नियम आणि अटी लागू)


​📞 अधिक माहिती आणि नोंदणीसाठी संपर्क:
​[तीर्थसारथी 
निनाद थत्ते [9689938912 ,8484037008]

​मर्यादित जागा उपलब्ध! आजच आपली जागा आरक्षित करा.

#Himalayas #CharDham #Tirthsarathi #EcoFriendlyTravel #Spirituality #KedarnathTemple #TravelIndia
​तुमच्या आध्यात्मिक प्रवासाचा खरा सोबती - तीर्थसारथी.`,
      price: "₹46,000/-",
      advance: "50% Advance",
      duration: "9 Nights / 10 Days",
      location: "Uttarakhand (Yamunotri, Gangotri, Kedarnath, Badrinath)",
      contactValue: "chardham",
      bgColor: "linear-gradient(135deg, #f5af19 0%, #f12711 100%)",
      features: [
        { icon: "👤", text: "वैयक्तिक लक्ष – प्रत्येक यात्रेकरूची काळजी" },
        { icon: "🚩", text: "अनुभवी टूर लीडर" },
        { icon: "🧘", text: "Pre-Trip Coaching (शारीरिक व मानसिक तयारी)" },
        { icon: "🌿", text: "Sustainable Tourism (प्लास्टिक-मुक्त प्रवास)" },
        { icon: "🏛️", text: "मंदिरांचा इतिहास व वारसा समजून घेण्याची संधी" },
        { icon: "🤝", text: "सुरक्षित व शिस्तबद्ध नियोजन (ज्येष्ठ नागरिकांसाठी विशेष सुविधा)" }
      ]
    },
    {
      id: 5,
      img: require("../assets/images/home5.webp"), // Add this image to your assets
      bannerImg: require("../assets/images/kanherimathkolhapur.jpg"), // Add banner image
      title: "सिद्धगिरी कारागीर महोत्सव आणि कणेरी मठ दर्शन",
      date: "April 4, 2026",
      author: "तीर्थसारथी",
      desc: "१ दिवस | सिद्धगिरी कारागीर महोत्सव | संग्रहालय दर्शन | भव्य शिव मंदिर | ग्रामीण खाद्यसंस्कृती | ₹1,500/- per person",
      fullDescription: `🚩 तीर्थसारथी आयोजित: विशेष सहल - सिद्धगिरी कारागीर महोत्सव आणि कणेरी मठ दर्शन 🚩

📅 शनिवार, ४ एप्रिल २०२६

अनुभवा भारतीय हस्तकलेचा वारसा आणि ग्रामजीवनाचे दर्शन!

सिद्धगिरी (कणेरी मठ) येथे सध्या 'सिद्धगिरी कारागीर महोत्सव' मोठ्या उत्साहात सुरू आहे. देशभरातील नामवंत कारागीर, त्यांची कला आणि मराठमोळी संस्कृती एकाच ठिकाणी पाहण्याची ही सुवर्णसंधी सोडू नका!

🌟 या सहलीची खास वैशिष्ट्ये:

🎨 सिद्धगिरी कारागीर महोत्सव:
• टेराकोटा, मातीची ज्वेलरी, खेळणी
• टॅनिंग वुड कला, बांबू काम, लेदर वर्क
• पिंगुळी चित्रकला, आदिवासी भिल्ल चित्रकला
• धागा चित्रकला, बाहुलींच्या प्रतीकात्मक ऐतिहासिक मुर्ती
• स्टोन वर्क, कच्छ मधील राबरी कला
• ग्लास वर्क, मक्याच्या कणसाचे वेस्टर्न पासून वस्तू
• मधुवेनी पेंटिंग, लाकेपासून बांगड्या
• महाराष्ट्राची पैठणी, बंजारा कला, बनारसी जरदोशी साड्या

हस्तकलेचे विविध प्रकार या कारागीर महाकुंभामध्ये बघायला आणि विक्रीसाठी मिळतील.

🏛️ सिद्धगिरी संग्रहालय: 
१२ बलुतेदार पद्धतीवर आधारित जगातील सर्वात मोठे मेणाचे आणि मातीचे शिल्प संग्रहालय.

🛕 भव्य शिव मंदिर: 
शांत आणि प्रसन्न वातावरणात आध्यात्मिक दर्शन.

🍽️ ग्रामीण खाद्यसंस्कृती: 
महोत्सवाच्या निमित्ताने खास गावरान जेवणाचा आस्वाद.

📅 सहलीचे नियोजन (इटिनररी):

⏰ पहाटे ५:००: पुणे येथून प्रस्थान (नाश्ता प्रवासात)
⏰ सकाळी १०:३०: कणेरी मठ आगमन
⏰ सकाळी ११:०० ते १:३०: सिद्धगिरी कारागीर महोत्सवाचा आनंद आणि खरेदी
⏰ दुपारी १:३० ते २:३०: चविष्ट गावरान शाकाहारी जेवण
⏰ दुपारी २:३० ते ५:००: मुख्य सिद्धगिरी संग्रहालय दर्शन आणि मंदिर परिसर भेट
⏰ संध्याकाळी ५:३०: परतीचा प्रवास सुरू (चहा-नाश्ता करून)

💰 सहल शुल्क:
प्रति व्यक्ती: ₹1,500/-

✅ समाविष्ट:
• प्रवास (पुणे ते सिद्धगिरी परत)
• नाश्ता
• दुपारचे गावरान जेवण
• संध्याकाळी चहा-नाश्ता
• मठाचे अधिकृत प्रवेश तिकीट

❌ समाविष्ट नाही:
• वैयक्तिक खर्च
• महोत्सवातील खरेदी

📞 अधिक माहिती व नाव नोंदणीसाठी:
निनाद थत्ते
📱 मोबाईल: 9689938912 / 8484037008

⚠️ महत्वाची सूचना:
• महोत्सव मर्यादित काळासाठीच आहे
• आजच आपली जागा निश्चित करा!
• जागा मर्यादित असल्याने लवकर नोंदणी करावी

"महोत्सव मर्यादित काळासाठीच आहे, आजच आपली जागा निश्चित करा!"`,
      price: "₹1,500/-",
      advance: "Full Payment",
      duration: "1 Day",
      location: "Siddhagiri, Kaneri, Kolhapur, Maharashtra",
      contactValue: "siddhagiri",
      bgColor: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      features: [
        { icon: "🎨", text: "देशभरातील ५०+ हस्तकला कलाकारांचे प्रदर्शन" },
        { icon: "🏛️", text: "जगातील सर्वात मोठे मेणाचे शिल्प संग्रहालय" },
        { icon: "🛕", text: "प्राचीन कणेरी मठ आणि भव्य शिव मंदिर दर्शन" },
        { icon: "🍽️", text: "प्रामाणिक गावरान शाकाहारी जेवणाचा आस्वाद" },
        { icon: "🚩", text: "तीर्थसारथीचे अनुभवी मार्गदर्शन" },
        { icon: "🛍️", text: "थेट कारागिरांकडून खरेदीची संधी" },
        { icon: "📸", text: "फोटोग्राफी उत्साहींसाठी परफेक्ट ठिकाण" },
        { icon: "⏰", text: "एकदिवसीय सहल - कुटुंबासहित आनंद घ्या" }
      ]
    },
    {
      id: 6,
      img: kailashImg,
      bannerImg: require("../assets/images/Kailas.jpg"),
      title: "कैलास मानसरोवर यात्रा २०२६",
      date: "September 22 - October 4, 2026",
      author: "तीर्थसारथी",
      desc: "१३ रात्री / १४ दिवस | काठमांडू दर्शन | कैलास परिक्रमा | मानसरोवर तट | ₹2,10,000/- Ex. मुंबई",
      fullDescription: `🔱 ॐ नमः शिवाय 🔱
कैलास मानसरोवर यात्रा २०२६
आत्मसाक्षात्काराचा एक अद्भुत प्रवास!

कैलास आणि मानसरोवर: निसर्गाचे लेणे - देवाचे घर

कैलास पर्वत:
हिंदू धर्मात कैलास हे भगवान शिवाचे निवासस्थान मानले जाते. याला 'ब्रह्मांडाचे केंद्र' (Axis Mundi) म्हटले जाते. असे मानले जाते की कैलास पर्वताची एक परिक्रमा केल्याने जन्मांतराची पापे धुऊन निघतात.

मानसरोवर:
ब्रह्माच्या मनातून उत्पन्न झालेले हे जगातील सर्वात उंच गोड्या पाण्याचे सरोवर आहे. सूर्याच्या पहिल्या किरणांनी उजळून निघणारे मानसरोवर आणि त्यातील स्नान मनाला शांती आणि शरीराला ऊर्जा प्रदान करते.

🗓️ यात्रेचे नियोजन:
• दिनांक: २२ सप्टेंबर ते ४ ऑक्टोबर २०२६  
• कालावधी: १४ दिवस / १३ रात्री  
• प्रस्थान: काठमांडू (Ex-Kathmandu)  

💰 शुल्क: ₹2,10,000/-  
नोंदणी शुल्क: ₹25,000/-  

✨ तीर्थसारथीची विशेष वैशिष्ट्ये:
• 🚩 आध्यात्मिक प्रवास – नामस्मरण आणि सत्संग  
• 🏔️ हाय-अल्टिट्यूड तयारी + सराव सत्र  
• 🍲 आरोग्यस्नेही भोजन  
• 🤝 वैयक्तिक लक्ष  
• 🛡️ सुरक्षा आणि अनुभवी टीम  

🌟 मुख्य आकर्षण:
• काठमांडू दर्शन – पशुपतिनाथ मंदिर  
• कैलास परिक्रमा – यमद्वारापासून  
• मानसरोवर तट – ध्यान आणि अनुभव  

🚩 शिवभक्तांसाठी सुवर्णसंधी!
कैलासाचे दर्शन घेण्याचे स्वप्न पूर्ण करा तीर्थसारथी सोबत.

(In case of cancellation credit note facility is available - T&C apply)

📞 संपर्क:
निनाद थत्ते  
📱 9689938912 / 8484037008  

🌐 वेबसाइट:
https://gypsycompanion.com/

तीर्थसारथी – जिथे भक्ती आणि सेवा यांचा संगम होतो!`,
      price: "₹2,10,000/-",
      advance: "25000 Advance",
      duration: "13 Nights / 14 Days",
      location: "Kathmandu, Kailash, Mansarovar, Tibet",
      contactValue: "kailash",
      bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      features: [
        { icon: "🚩", text: "आध्यात्मिक वातावरण व सत्संग" },
        { icon: "🏔️", text: "हाय अल्टिट्यूड मार्गदर्शन" },
        { icon: "🍲", text: "आरोग्यदायी भोजन व्यवस्था" },
        { icon: "🛡️", text: "पूर्ण सुरक्षा व्यवस्था" },
        { icon: "🛕", text: "पशुपतिनाथ मंदिर दर्शन" },
        { icon: "🌊", text: "मानसरोवर ध्यान अनुभव" }
      ]
    },

    {
      id: 7,
      img: valleyFlowersImg,
      bannerImg: require("../assets/images/ValleyofFlowersTrekwithGypsyClub.jpeg"),
      title: "Valley of Flowers Trek 2026",
      date: "August 3-8, 2026",
      author: "Gypsy Club",
      desc: "६ दिवस / ५ रात्री | Valley of Flowers | Hemkund Sahib | ₹16,000/- Ex. Dehradun",
      fullDescription: `🌸 Valley of Flowers Trek with Gypsy Club 🌸

Join Gypsy Club for a magical journey into the heart of the UNESCO World Heritage Site – Valley of Flowers.

📅 Dates:
3 August to 8 August 2026
(Monday to Saturday)
Duration: 6 Days / 5 Nights

📍 Starting Point:
Dehradun

🥾 Trek Details:
• Difficulty: Easy to Moderate
• Total Trek Distance: 36 KM
• Maximum Altitude: 14,000 ft

💰 Fees:
₹16,000/- Ex. Dehradun
Advance: 50%

(Group discount and full payment discount available)

✨ Trek Itinerary:

Day 1:
Drive from Dehradun to Govindghat through beautiful Alaknanda and Bhagirathi valleys.

Day 2:
Govindghat to Ghangaria trek (12 KM)
Walk alongside the beautiful Laxman Ganga river.

Day 3:
Valley of Flowers Trek (6 KM up & down)
Experience Himalayan flowers like Blue Poppies, Brahma Kamal and Lilies.

Day 4:
Hemkund Sahib Trek (6 KM)
Visit the world’s highest Gurudwara beside the glacial lake at 14,107 ft.

Day 5:
Descend from Ghangaria to Govindghat (12 KM)

Day 6:
Return journey to Dehradun with unforgettable memories.

✅ Fees Include:
• Transportation from Dehradun to Dehradun
• Homestay / Guest House Stay
• Camps at Ghangaria
• All meals, tea & snacks during trek
• Tent and sleeping bag arrangements

✨ Why Trek with Gypsy Club?
• Expert Trek Leaders
• Sustainable Travel Approach
• Photography Friendly Schedule
• Local Culture & Heritage Experience

(In case of cancellation, credit note facility available. T&C Apply)

📞 Contact:
Ninad Thatte
9689938912 / 8484037008

🌐 www.gypsycompanion.com`,
      price: "₹16,000/-",
      advance: "50% Advance",
      duration: "6 Days / 5 Nights",
      location: "Valley of Flowers, Uttarakhand",
      contactValue: "valley-flowers",
      bgColor: "linear-gradient(135deg, #43cea2 0%, #185a9d 100%)",
      features: [
        { icon: "🌸", text: "UNESCO World Heritage Site Trek" },
        { icon: "⛰️", text: "Hemkund Sahib Trek Included" },
        { icon: "📸", text: "Photography Friendly Trek" },
        { icon: "🥾", text: "Easy to Moderate Difficulty" },
        { icon: "🏕️", text: "Camping & Guest House Stay" },
        { icon: "🍲", text: "Meals, Tea & Snacks Included" }
      ]
    },
    {
      id: 8,
      img: pinBhabaImg,
      bannerImg: require("../assets/images/ValleyofFlowersTrekwithGypsyClub.jpeg"),
      title: "Pin Bhaba Pass Trek",
      date: "July 17-23, 2026",
      author: "Gypsy Club",
      desc: "७ दिवस | Bhaba Valley | Pin Valley | Himalayan Crossover Trek | ₹22,500/-",
      fullDescription: `🏔️ Pin Bhaba Pass Trek Organized by Gypsy Club

Experience the magic of the Ultimate Himalayan Crossover Trek.

If you want to experience two completely different worlds of the Himalayas in one journey, this trek is perfect for you.

✨ Trek Highlights:

🌿 Begin in the lush green meadows of Bhaba Valley.
🏜️ End in the rugged cold desert landscapes of Spiti Valley.
🌲 Dense forests, rivers and alpine meadows.
⭐ Beautiful campsites under starry skies.
🌊 Thrilling riverside trekking experience.

📅 Trek Dates:
17 July to 23 July 2026

🥾 Trek Grade:
Moderate to Difficult

💰 Fees:
₹22,500/- (Shimla to Manali)

🔥 Early Bird Offer:
₹20,999/- till 15 May

Advance: 50%

✅ Why Choose This Trek?
• Dual Valley Experience
• Riverside Camping
• Stunning Himalayan Landscapes
• Experienced Trek Leaders
• Delicious Mountain Meals

🏕️ Major Camps:
• Kafnu
• Mulling
• Kara

✨ Special Experience:
Witness the dramatic transition from green Himalayan valleys to the barren beauty of Spiti.

(In case of cancellation, credit note facility available. T&C Apply)

📞 Contact:
Ninad Thatte
9689938912 / 8484037008

🌐 www.gypsycompanion.com

🌿 Practice Responsible Trekking`,
      price: "₹22,500/-",
      advance: "50% Advance",
      duration: "7 Days",
      location: "Shimla to Spiti Valley",
      contactValue: "pin-bhaba",
      bgColor: "linear-gradient(135deg, #8360c3 0%, #2ebf91 100%)",
      features: [
        { icon: "🏔️", text: "Ultimate Himalayan Crossover Trek" },
        { icon: "🌿", text: "Bhaba Valley Green Landscapes" },
        { icon: "🏜️", text: "Cold Desert Experience of Spiti" },
        { icon: "🏕️", text: "Beautiful Riverside Camping" },
        { icon: "⭐", text: "Scenic High Altitude Campsites" },
        { icon: "🥾", text: "Moderate to Difficult Adventure Trek" }
      ]
    },
  ];

  // Helper function to render features in 2-column layout
  const renderFeatures = (features) => {
    if (!features) return null;

    return (
      <div className="features-section mt-4">
        <h4 className="mb-3" style={{ fontSize: "1.25rem", fontWeight: "600", color: "#333" }}>
          ✨ यात्रेची प्रमुख वैशिष्ट्ये:
        </h4>
        <div className="row">
          {features.map((feature, index) => (
            <div className="col-md-6 mb-3" key={index}>
              <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                <span style={{ fontSize: "1.2rem", minWidth: "30px" }}>{feature.icon}</span>
                <span style={{ lineHeight: "1.4", color: "#555" }}>{feature.text}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Helper function to render itinerary
  const renderItinerary = (tour) => {
    if (tour.id === 5) {
      return (
        <div className="itinerary-section mt-4">
          <h4 className="mb-3" style={{ fontSize: "1.25rem", fontWeight: "600", color: "#333" }}>
            📅 सहलीचे नियोजन (इटिनररी):
          </h4>
          <div className="timeline">
            <div className="timeline-item mb-3">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary me-3 p-2">⏰ ५:०० AM</span>
                <span>पुणे येथून प्रस्थान (नाश्ता प्रवासात)</span>
              </div>
            </div>
            <div className="timeline-item mb-3">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary me-3 p-2">⏰ १०:३० AM</span>
                <span>कणेरी मठ आगमन</span>
              </div>
            </div>
            <div className="timeline-item mb-3">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary me-3 p-2">⏰ ११:०० AM - १:३० PM</span>
                <span>सिद्धगिरी कारागीर महोत्सवाचा आनंद आणि खरेदी</span>
              </div>
            </div>
            <div className="timeline-item mb-3">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary me-3 p-2">⏰ १:३० PM - २:३० PM</span>
                <span>चविष्ट गावरान शाकाहारी जेवण</span>
              </div>
            </div>
            <div className="timeline-item mb-3">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary me-3 p-2">⏰ २:३० PM - ५:०० PM</span>
                <span>मुख्य सिद्धगिरी संग्रहालय दर्शन आणि मंदिर परिसर भेट</span>
              </div>
            </div>
            <div className="timeline-item mb-3">
              <div className="d-flex align-items-start">
                <span className="badge bg-primary me-3 p-2">⏰ ५:३० PM</span>
                <span>परतीचा प्रवास सुरू (चहा-नाश्ता करून)</span>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  // Find the tour with matching id
  const tour = tours.find(t => t.id === parseInt(id));

  if (!tour) {
    return (
      <>
        <Navbar />
        <div className="site-section">
          <div className="container text-center">
            <h2>Tour Not Found</h2>
            <p>Sorry, the tour you're looking for doesn't exist.</p>
            <Link to="/tour" className="btn btn-primary">Back to Tours</Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />

      {/* Hero Section with Dynamic Banner Image - Lighter Overlay */}
      <div className="ftco-blocks-cover-1">
        <div
          className="site-section-cover"
          style={{
            backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.4)), url(${tour.bannerImg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "50vh",
            minHeight: "400px",
            position: "relative"
          }}
        >
          <div className="container h-100">
            <div
              className="row align-items-center justify-content-center text-center h-100"
              style={{ height: "100%" }}
            >
              <div className="col-md-8" data-aos="fade-up">
                {/* Animated Badges */}
                <div className="d-flex justify-content-center gap-2 mb-3 animate__animated animate__fadeInDown">
                  <span className="badge bg-warning text-dark px-3 py-2" style={{ backdropFilter: "blur(5px)" }}>
                    <i className="bi bi-clock me-1"></i> {tour.duration}
                  </span>
                  <span className="badge bg-info text-dark px-3 py-2" style={{ backdropFilter: "blur(5px)" }}>
                    <i className="bi bi-geo-alt me-1"></i> {tour.location}
                  </span>
                  <span className="badge bg-success px-3 py-2" style={{ backdropFilter: "blur(5px)" }}>
                    <i className="bi bi-tag me-1"></i> {tour.price}
                  </span>
                </div>

                <h1 className="mb-3 text-white display-3 fw-bold text-shadow animate__animated animate__fadeInUp">
                  {tour.title}
                </h1>

                <p className="text-white lead animate__animated animate__fadeInUp animate__delay-1s">
                  <i className="bi bi-calendar-event me-2"></i> {tour.date}
                  <span className="mx-2">|</span>
                  <i className="bi bi-person-circle me-2"></i> Organized by {tour.author}
                </p>

                {/* Scroll Down Indicator */}
                <div className="scroll-indicator mt-4 animate__animated animate__fadeInUp animate__delay-2s">
                  <a href="#tour-content" className="text-white">
                    <i className="bi bi-chevron-double-down fs-2"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tour Content */}
      <div id="tour-content" className="site-section py-5">
        <div className="container">
          <div className="row g-5">
            {/* LEFT CONTENT */}
            <div className="col-lg-8">
              {/* Tour Image - Smaller and Styled */}
              <div className="card shadow-sm border-0 mb-4 overflow-hidden">
                <div className="row g-0">
                  <div className="col-md-5">
                    <img
                      src={tour.img}
                      alt={tour.title}
                      className="img-fluid h-100 object-fit-cover"
                      style={{ objectFit: "cover", height: "280px", width: "100%" }}
                    />
                  </div>
                  <div className="col-md-7">
                    <div className="card-body">
                      <h3 className="card-title text-primary mb-3">{tour.title}</h3>
                      <div className="d-flex flex-wrap gap-3 mb-3">
                        <div className="d-flex align-items-center">
                          <i className="bi bi-calendar3 me-2"></i>
                          <span>{tour.date}</span>
                        </div>
                        <div className="d-flex align-items-center">
                          <i className="bi bi-person me-2"></i>
                          <span>{tour.author}</span>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-6">
                          <div className="border rounded p-2 text-center bg-light">
                            <small className="text-muted">Tour Cost</small>
                            <h5 className="text-primary mb-0">{tour.price}</h5>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="border rounded p-2 text-center bg-light">
                            <small className="text-muted">Advance</small>
                            <h5 className="text-success mb-0">{tour.advance}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Tour Details */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-body p-4">
                  <h3 className="mb-4">
                    <i className="bi bi-info-circle-fill text-primary me-2"></i>
                    Tour Details
                  </h3>
                  <div className="tour-description">
                    <p style={{ whiteSpace: "pre-wrap", lineHeight: "1.8", fontSize: "1rem" }}>
                      {tour.fullDescription}
                    </p>
                    {/* Render itinerary for Siddhagiri tour */}
                    {renderItinerary(tour)}
                    {/* Render features if available */}
                    {renderFeatures(tour.features)}
                  </div>
                </div>
              </div>

              {/* Action Buttons - Updated with tour selection */}
              <div className="d-flex gap-3 mt-4">
                <Link to="/tour" className="btn btn-outline-secondary px-4 py-2">
                  ← Back to Tours
                </Link>
                <Link
                  to="/contact"
                  state={{
                    tour: tour.title,
                    tourId: tour.id,
                    dates: tour.dates
                  }}
                  className="btn btn-primary px-4 py-2 shadow"
                >
                  📞 Book Now - {tour.price}
                </Link>
                <Link
                  to={`/contact?tour=${encodeURIComponent(tour.title)}&tourId=${tour.id}`}
                  className="btn btn-success px-4 py-2 shadow"
                >
                  💬 Inquire Now
                </Link>
              </div>
            </div>

            {/* SIDEBAR */}
            <div className="col-lg-4">
              {/* Quick Info Card */}
              <div className="card shadow-sm border-0 mb-4" style={{ top: "20px" }}>
                <div className="card-header text-white py-3" style={{ background: tour.bgColor }}>
                  <h4 className="mb-0"><i className="bi bi-info-circle me-2"></i>Quick Info</h4>
                </div>
                <div className="card-body">
                  <div className="mb-3 pb-2 border-bottom">
                    <i className="bi bi-cash-stack text-primary me-2"></i>
                    <strong>Tour Cost:</strong>
                    <h3 className="text-primary mt-1">{tour.price}</h3>
                  </div>
                  <div className="mb-3 pb-2 border-bottom">
                    <i className="bi bi-credit-card text-success me-2"></i>
                    <strong>Advance Payment:</strong>
                    <p className="text-success mt-1 mb-0 fw-bold">{tour.advance}</p>
                  </div>
                  <div className="mb-3 pb-2 border-bottom">
                    <i className="bi bi-clock me-2"></i>
                    <strong>Duration:</strong>
                    <p className="mt-1 mb-0">{tour.duration}</p>
                  </div>
                  <div className="mb-3 pb-2 border-bottom">
                    <i className="bi bi-geo-alt me-2"></i>
                    <strong>Location:</strong>
                    <p className="mt-1 mb-0">{tour.location}</p>
                  </div>
                  <div className="mb-3 pb-2 border-bottom">
                    <i className="bi bi-calendar-week me-2"></i>
                    <strong>Travel Date:</strong>
                    <p className="mt-1 mb-0">{tour.date}</p>
                  </div>
                </div>
              </div>

              {/* Tour Highlights */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header text-white py-3" style={{ background: tour.bgColor }}>
                  <h4 className="mb-0"><i className="bi bi-star-fill me-2"></i>✨ Tour Highlights</h4>
                </div>
                <div className="card-body">
                  <ul className="list-unstyled">
                    <li className="mb-2">✓ Expert Local Guides</li>
                    <li className="mb-2">✓ Comfortable Accommodation</li>
                    <li className="mb-2">✓ Delicious Regional Meals</li>
                    <li className="mb-2">✓ Safe & Secure Travel</li>
                    <li className="mb-2">✓ Best Price Guarantee</li>
                    <li className="mb-2">✓ 24/7 Customer Support</li>
                  </ul>
                </div>
              </div>

              {/* Contact Card */}
              <div className="card shadow-sm border-0 mb-4">
                <div className="card-header text-white py-3" style={{ background: tour.bgColor }}>
                  <h4 className="mb-0"><i className="bi bi-telephone-fill me-2"></i>📞 Contact Us</h4>
                </div>
                <div className="card-body">
                  <p className="mb-2">
                    <strong>Phone:</strong><br />
                    <a href="tel:9689938912" className="text-decoration-none">9689938912</a><br />
                    <a href="tel:8484037008" className="text-decoration-none">8484037008</a>
                  </p>
                  <p className="mb-2">
                    <strong>Email:</strong><br />
                    <a href="mailto:gypsycompanion@gmail.com">gypsycompanion@gmail.com</a>
                  </p>
                  <p className="mb-0">
                    <strong>Office:</strong><br />
                    Pune, Maharashtra, India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Add CSS for animations */}
      <style>
        {`
          @keyframes fadeInDown {
            from {
              opacity: 0;
              transform: translateY(-30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .animate__fadeInDown {
            animation: fadeInDown 0.8s ease-out;
          }
          
          .animate__fadeInUp {
            animation: fadeInUp 0.8s ease-out;
          }
          
          .animate__delay-1s {
            animation-delay: 0.3s;
            opacity: 0;
            animation-fill-mode: forwards;
          }
          
          .animate__delay-2s {
            animation-delay: 0.6s;
            opacity: 0;
            animation-fill-mode: forwards;
          }
          
          .scroll-indicator {
            cursor: pointer;
            animation: bounce 2s infinite;
          }
          
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-20px);
            }
            60% {
              transform: translateY(-10px);
            }
          }
          
          .sticky-top {
            position: sticky;
            top: 20px;
          }
          
          .timeline-item {
            padding-left: 0;
            border-left: none;
          }
        `}
      </style>
    </>
  );
}

export default Tourdetails;